import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer id="t-footer" className="t-records">
      <div style={{
        backgroundColor: 'var(--ozarks-white)', 
        borderTop: '1px solid #E9ECEF', 
        paddingTop: '40px', 
        paddingBottom: '25px'
      }}>
        <div className="t-container">
          <div className="footer-grid" style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr',
            gap: '40px',
            alignItems: 'start'
          }}>
            {/* Section Logo et Description */}
            <div>
              <Link to="/">
                <img 
                  src="/images/ozarkselec-logo-bleu.png"
                  style={{maxWidth: '180px', marginBottom: '20px'}} 
                  alt="Ozarkselec" 
                />
              </Link>
              <p style={{
                color: 'var(--ozarks-gray)', 
                fontSize: '16px', 
                lineHeight: '1.6',
                maxWidth: '300px',
                marginBottom: '20px'
              }}>
                Votre expert en électricité et bâtiment général dans l'Aisne, la Thiérache, 
                la métropole lilloise et le valenciennois. 
                Interventions professionnelles pour particuliers et entreprises.
              </p>
              <div style={{
                fontSize: '14px',
                color: 'var(--ozarks-gray)',
                lineHeight: '1.5'
              }}>
                <div style={{marginBottom: '8px'}}>
                  <strong style={{color: 'var(--ozarks-blue-dark)'}}>📍</strong> Viesly, Nord (59)
                </div>
                <div style={{marginBottom: '8px'}}>
                  <strong style={{color: 'var(--ozarks-blue-dark)'}}>📞</strong> 06 30 98 45 78
                </div>
                <div>
                  <strong style={{color: 'var(--ozarks-blue-dark)'}}>✉️</strong> contact@ozarkselec.com
                </div>
              </div>
            </div>

            {/* Section Services */}
            <div>
              <h4 style={{
                color: 'var(--ozarks-blue-dark)', 
                fontSize: '18px', 
                fontWeight: 600, 
                marginBottom: '15px',
                textTransform: 'uppercase'
              }}>
                Nos Services
              </h4>
              <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <Link to="/elecgnrle" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Électricité Générale
                </Link>
                <Link to="/batiment" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Bâtiment Général
                </Link>
                <Link to="/irve" className="t981__menu-link" style={{fontSize: '15px'}}>
                  IRVE - Bornes de Recharge
                </Link>
                <Link to="/maintenindus" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Maintenance Industrielle
                </Link>
                <Link to="/habielec" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Habilitation Électrique
                </Link>
              </div>
            </div>

            {/* Section Informations */}
            <div>
              <h4 style={{
                color: 'var(--ozarks-blue-dark)', 
                fontSize: '18px', 
                fontWeight: 600, 
                marginBottom: '15px',
                textTransform: 'uppercase'
              }}>
                Informations
              </h4>
              <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <Link to="/contact" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Contact
                </Link>
                <Link to="/rse" className="t981__menu-link" style={{fontSize: '15px'}}>
                  RSE
                </Link>
                <Link to="/cgv" className="t981__menu-link" style={{fontSize: '15px'}}>
                  CGV
                </Link>
                <Link to="/mentions-legales" className="t981__menu-link" style={{fontSize: '15px'}}>
                  Mentions Légales
                </Link>
              </div>
            </div>
          </div>

          {/* Ligne de séparation et Copyright */}
          <div style={{
            borderTop: '1px solid #E9ECEF',
            marginTop: '30px',
            paddingTop: '20px',
            textAlign: 'center'
          }}>
            <span style={{
              color: 'var(--ozarks-gray)', 
              fontSize: '14px', 
              fontWeight: 500
            }}>
              © 2026 Ozarkselec. Tous droits réservés.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;